// UploadDocumentPage.tsx
import ApplicantTabs from "../common-features/ApplicantTabs";

const UploadDocument = ({
  tabsList,
  applicationDetail,
  mainApplicantDetails,
  coApplicantDetails,
  applicationId,
  handleFetchApplicationDetail,
  partnerStartedJourney,
  dropdownData,
  applicationStatus,
  coApplicantEmploymentType,
  isPayPartyPresent,
  isPayPartyValue,
}: any) => {
  return (
    <ApplicantTabs
      applicants={tabsList}
      applicationDetail={applicationDetail}
      mainApplicantDetails={mainApplicantDetails}
      coApplicantDetails={coApplicantDetails}
      handleFetchApplicationDetail={handleFetchApplicationDetail}
      partnerStartedJourney={partnerStartedJourney}
      dropdownData={dropdownData}
      applicationStatus={applicationStatus}
      coApplicantEmploymentType={coApplicantEmploymentType || ""}
      isPayPartyPresent={isPayPartyPresent}
      isPayPartyValue={isPayPartyValue}
    />
  );
};

export default UploadDocument;
